(() => {
  if (customElements.get('norbites-cart-gift')) return;
  let busy = false;
  const root = () => window.Shopify?.routes?.root || '/';
  async function request(path, data) {
    const response = await fetch(root() + path, {credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},...(data ? {method:'POST',body:JSON.stringify(data)} : {})});
    if (!response.ok) throw new Error('cart_request_failed');
    return response.json();
  }
  function refresh(cart) {
    if (typeof window.buildCart !== 'function') throw new Error('drawer_unavailable');
    window.buildCart(cart, true);
  }
  customElements.define('norbites-cart-gift', class extends HTMLElement {
    connectedCallback() {
      this.onclick = async event => {
        const button = event.target.closest('[data-gift-action]');
        if (!button || busy) return;
        event.preventDefault();
        busy = true;
        const status = this.querySelector('[data-gift-status]');
        const messages = JSON.parse(this.querySelector('[data-gift-messages]').textContent);
        button.disabled = true;
        status.textContent = messages.busy;
        try {
          let cart = await request('cart.js');
          const variant = Number(this.dataset.variant);
          if (button.dataset.giftAction === 'remove') {
            const item = cart.items.find(item => item.key === this.dataset.itemKey);
            if (item) cart = await request('cart/change.js', {id:item.key,quantity:0});
            refresh(cart);
            return;
          }
          if (Date.now() >= Number(this.dataset.end) * 1000) {status.textContent=messages.expired;return;}
          if (cart.items.some(item => item.product_id === Number(this.dataset.product))) {status.textContent=messages.existing;refresh(cart);return;}
          const spend = cart.items.filter(item => item.product_id !== Number(this.dataset.product)).reduce((sum,item)=>sum+item.original_line_price,0);
          if (cart.currency !== this.dataset.currency || !Number.isFinite(Number(this.dataset.minimum)) || Number(this.dataset.minimum) <= 0 || spend < Number(this.dataset.minimum)) {status.textContent=messages.ineligible;return;}
          const claim = crypto.randomUUID();
          await request('cart/add.js',{items:[{id:variant,quantity:1,properties:{_norbites_gift:String(this.dataset.product) + ':' + this.dataset.end,_norbites_gift_claim:claim}}]});
          cart = await request('cart.js');
          const added = cart.items.find(item=>item.properties?._norbites_gift_claim === claim);
          if (!added || added.final_line_price !== 0) {
            if (added) await request('cart/change.js',{id:added.key,quantity:0});
            status.textContent=messages.ineligible;
            return;
          }
          refresh(cart);
        } catch (error) {
          status.textContent=messages.failed;
        } finally {
          busy=false;
          button.disabled=false;
        }
      };
    }
  });
})();